module.exports = __webpack_public_path__ + "media/images/icons/structure-icon-21b52dc9c8a259df0a940de9513649c2.svg";